import { useTranslation } from "react-i18next";

import { Text, ErrorMsg } from "@fragments";
import { SellRounded } from "@mui/icons-material";

import AvailabilityInPlan from "@components/AvailabilityInPlan";

import General from "./components/General";
import DescriptionLinks from "./components/DescriptionLinks";
import Interactions from "./components/Interactions";
import TypeSelector from "./components/TypeSelector";
import ExpirationSettings from "./components/ExpirationSettings";
import Awards from "./components/Awards";
import GamificationSettings from "./components/GamificationSettings";

import "./styles.scss";

export default function ManageGroupView({
    configRef,
    communityRef,
    type,
    errors = {},
    clearError = () => {},
    onTypeChange,
    onAvailabilityChange,
    onUploadBusyChange,
}) {
    const { t } = useTranslation("groupModals");
    const isChallenge = type === "CHALLENGE";
    const communityId = communityRef.current?.id
        ? parseInt(communityRef.current.id)
        : null;

    return (
        <div className="px-4 py-1">
            <General
                configRef={configRef}
                communityId={communityId}
                onUploadingChange={onUploadBusyChange}
                errors={errors}
                clearError={clearError}
            />

            <DescriptionLinks
                configRef={configRef}
                errors={errors}
                clearError={clearError}
            />

            <Text.h3
                className="mt-4 mb-2"
                left={<SellRounded />}
                value={t("manageGroup.availability.title")}
            />

            <AvailabilityInPlan
                community={communityRef.current?.id}
                initialValues={configRef.current?.plans}
                onChange={onAvailabilityChange}
                className="mt-1"
            />
            {errors?.plans && <ErrorMsg>{errors.plans}</ErrorMsg>}

            <Interactions configRef={configRef} />

            <TypeSelector value={type} onChange={onTypeChange} />

            {isChallenge && (
                <>
                    <ExpirationSettings
                        configRef={configRef}
                        errors={errors}
                        clearError={clearError}
                    />
                    <Awards
                        configRef={configRef}
                        communityId={communityId}
                        onUploadingChange={onUploadBusyChange}
                        errors={errors}
                        clearError={clearError}
                    />
                    <GamificationSettings configRef={configRef} errors={errors} />
                </>
            )}
        </div>
    );
}
